export const getUrlByPublicId = (publicId: string) => `${window.location.origin}/checkout/${publicId}`;